import React, { useEffect, useState } from "react";
import * as Styles from "./styles";
import Header from "./Header";
import Footer from "./Footer";

interface Props {
  onClose: () => void;
  tableData: any;
  refetch: () => void;
  dataDetalheOportunidade?: any;
}

const AdicionarItemModal: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Header onClose={() => props?.onClose()} />
      <Footer
        onClose={() => props?.onClose()}
        tableData={props?.tableData}
        refetch={props?.refetch}
        dataDetalheOportunidade={props?.dataDetalheOportunidade}
      />
    </Styles.Container>
  );
};

export default AdicionarItemModal;
